import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Ruta protegida. Props opcionales:
 *   modulo  -> clave del módulo (p.ej. "rrhh"); exige permiso "ver" (o `accion`).
 *   accion  -> acción requerida (default "ver").
 * Si el usuario no tiene permiso muestra un aviso en lugar de la página.
 */
export default function ProtectedRoute({ children, modulo, accion = "ver", soloAdmin = false }) {
  const { user, loading, hasModule } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-app">
        <div className="h-10 w-10 border-2 border-agro-green border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const esAdmin = user.role === "admin" || Boolean(user.effective?.is_admin);
  if ((soloAdmin && !esAdmin) || (modulo && hasModule && !hasModule(modulo, accion))) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-app p-6" data-testid="no-permission">
        <div className="bg-card border border-border rounded-lg p-6 max-w-md text-center">
          <h2 className="font-heading text-lg font-semibold mb-2">Acceso restringido</h2>
          <p className="text-sm text-text-secondary mb-4">
            No tienes permiso para acceder a este módulo. Solicita acceso al administrador del sistema.
          </p>
          <Link to="/dashboard" className="inline-block px-4 py-2 text-sm bg-agro-green text-black font-medium rounded-md">
            Volver al Dashboard
          </Link>
        </div>
      </div>
    );
  }
  return children;
}
